import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { Iterable, Set } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import CommonPropTypes from '../../../../../../common/constants/proptypes/CommonPropTypes';
import AddonDiscoveryPropTypes from '../../../../../constants/proptypes/AddonDiscoveryPropTypes';
import FacetView from './FacetView';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DisjunctiveFacet(props) {
  const itemFactory = args => props.itemFactory(_objectSpread(_objectSpread({}, args), {}, {
    options: _objectSpread(_objectSpread({}, args.options), {}, {
      isChecked: args.options.selected
    })
  }));
  const isSelectedValue = facetProduct => {
    const filtersForThisFacet = props.filters.get(props.facet.get('key'));
    const facetProductsSelected = Iterable.isIterable(filtersForThisFacet) ? filtersForThisFacet : Set([filtersForThisFacet]);
    return facetProductsSelected.contains(facetProduct);
  };
  const createNewFilters = facetProduct => props.filters.update(props.facet.get('key'), fs => fs.includes(facetProduct) ? fs.delete(facetProduct) : fs.add(facetProduct));
  const fireAnalyticsEvent = useAnalyticsEvents();
  return /*#__PURE__*/_jsx(FacetView, {
    createNewFilters: createNewFilters,
    facet: props.facet,
    filters: props.filters,
    fireAnalyticsEvent: fireAnalyticsEvent,
    hiddenFilters: props.hiddenFilters,
    isSelectedValue: isSelectedValue,
    itemFactory: itemFactory,
    itemType: "checkbox",
    onFacetProductClick: props.onFacetProductClick,
    perspective: props.perspective,
    stateChangeRequested: props.stateChangeRequested,
    FacetComponent: props.FacetComponent
  });
}
DisjunctiveFacet.propTypes = {
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  FacetComponent: PropTypes.func.isRequired
};